var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-footer"},[_c('div',{staticClass:"conten"},[_c('img',{attrs:{"src":"/img/base/footer.png","alt":""}})]),_c('div',{staticClass:"copyright"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn"}},[_c('img',{attrs:{"src":"/img/base/copyright.png","alt":""}})])])])
}]

export { render, staticRenderFns }